const taskIsLocal = task => task.local

export default taskIsLocal